<div class="relative size-full">
  <div class="absolute top-[30%] flex w-full flex-row justify-center select-none">
    <div
      appDraggable
      #el
      class="absolute top-[30%] aspect-video size-fit bg-contain bg-center bg-no-repeat transition-transform"
      [ngStyle]="{ transform: clawVisible() ? 'none' : 'translateY(-50vh)' }"
      style="background-image: url(assets/placeholders/pipe.png)"
      (draggableGrabbed)="wk8AudioService.playClawMove()"
      (draggableTargetEntered)="wk8AudioService.playClawSnap()"
      [disabled]="wk8TutorService.isChecking()"
    >
      <div class="hitbox" style="position: absolute; inset: 0; top: -55%"></div>
      <!-- Question -->
      @let questionSettings = config().questionSettings;
      @if (questionSettings.showLabel) {
        <!-- TODO: the zIndex is done to make it overlay the overlay when doing the readcheck -->
        <div
          class="relative w-fit"
          [ngStyle]="{
            zIndex: 1000,
          }"
        >
          <wk8-claw-back [opened]="clawOpened()" [size]="clawSize()" class="absolute top-0 left-1/2" />
          <!-- Paper piece animates into the pipe while claw stays in place -->
          <div
            [ngStyle]="{
              transform: correctlyChosen() ? 'scale(0.1) translateY(150%)' : 'scale(1) translateY(0)',
              opacity: correctlyChosen() ? '0' : '1',
              transition: 'transform 0.3s ease-in, opacity 0.3s ease',
            }"
          >
            <wk8-paper-piece [hasFocus]="isReadingWord()" [style.font-size.px]="fontSize()">
              {{ question().label }}
            </wk8-paper-piece>
          </div>
          <wk8-claw-front lightColor="blue" [opened]="clawOpened()" [size]="clawSize()" class="absolute top-0 left-1/2"></wk8-claw-front>
        </div>
      }
      @if (questionSettings.showImage) {
        <img class="pointer-events-none select-none" [src]="question().image_url" [alt]="'Afbeelding van het woord ' + question().label" />
      }
    </div>
  </div>

  <!-- Pipes -->
  <div class="absolute bottom-0 flex h-1/3 w-full flex-row items-end justify-center gap-[12%] px-[7%] select-none">
    @let optionSettings = config().optionSettings;
    @for (option of shuffledOptions(); track option; let i = $index) {
      <div class="option relative flex h-full flex-1 flex-row justify-center">
        <!-- Hitbox that is larger than the pipe for easier snapping -->
        <div
          class="dropzone-hitbox absolute inset-0"
          lpDropTarget
          [dropPivot]="pipePivot()"
          (draggableAdded)="selectOption(option, $event)"
          style="pointer-events: auto; left: -15%; right: -15%; top: -25%; bottom: -15%"
        ></div>
        <wk8-input-pipe class="relative block h-full w-full" style="pointer-events: none">
          <div class="relative flex size-full items-center justify-center bg-white">
            @if (optionSettings.showImage) {
              <img
                class="absolute inset-0 h-full w-full object-cover"
                [src]="option.image_url"
                [alt]="'Afbeelding van het woord ' + option.label"
              />
            }
            @if (optionSettings.showLabel) {
              <div class="absolute inset-0 flex items-center justify-center text-3xl font-bold select-none">
                {{ option.label }}
              </div>
            }
          </div>
        </wk8-input-pipe>
        <wk8-audio-button
          #audioButton
          [audio]="option.audio_url"
          [cc]="option.label"
          style="position: absolute; left: -10%; top: 52%"
          [style.width.px]="scaleMultiplier() * 60"
          [style.height.px]="scaleMultiplier() * 60"
        />
      </div>
    }
  </div>
</div>

<wk8-ceiling class="absolute top-0 -mt-1" />
